var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { MessageType } from "../../models/message-type";
import { ViewType } from "../../models/view-type";
import { Base } from "../base";
import { ChatTextLoader } from "./chat-text-loader";
var ChatText = /** @class */ (function (_super) {
    __extends(ChatText, _super);
    function ChatText(type, text, backgroundColor, fontColor, viewType) {
        var _this = _super.call(this) || this;
        _this.setFullSizeWindow = function () {
            if (_this._type === MessageType.Assistant) {
                _this.self.style.maxWidth = '93%';
                _this.self.style.marginLeft = '';
            }
            else {
                _this.self.style.maxWidth = '82%';
                _this.self.style.marginLeft = '12%';
            }
        };
        _this.replaceText = function (text) {
            _this._loader.hide();
            _this.self.innerHTML = text;
            _this.openLinksInNewTab(_this.self);
        };
        _this.openLinksInNewTab = function (container) {
            container.querySelectorAll('a[href]').forEach(function (link) {
                link.setAttribute('target', '_blank');
                link.setAttribute('rel', 'noopener noreferrer');
            });
        };
        _this._type = type;
        var textElement = document.createElement('div');
        // null in text implicates enabling loader
        if (text === null) {
            _this._loader = new ChatTextLoader(fontColor);
            textElement.appendChild(_this._loader.self);
        }
        else {
            textElement.innerHTML = text;
            _this.openLinksInNewTab(textElement);
        }
        textElement.style.backgroundColor = backgroundColor;
        textElement.style.color = fontColor;
        textElement.style.borderRadius = '5px';
        textElement.style.paddingLeft = '10px';
        textElement.style.paddingRight = '10px';
        textElement.style.paddingTop = '2px';
        textElement.style.paddingBottom = '2px';
        textElement.style.float = type === MessageType.Assistant ? 'left' : 'right';
        textElement.style.marginTop = '11px';
        textElement.style.overflowWrap = 'anywhere';
        textElement.style.wordBreak = 'break-word';
        _this.self = textElement;
        if (viewType === ViewType.DesktopSmall) {
            _this.setSmallSizeWindow();
        }
        else {
            _this.setFullSizeWindow();
        }
        return _this;
    }
    ChatText.prototype.setSmallSizeWindow = function () {
        if (this._type === MessageType.Assistant) {
            this.self.style.maxWidth = '78%';
            this.self.style.marginLeft = '';
        }
        else {
            this.self.style.maxWidth = '65%';
            this.self.style.marginLeft = '10%';
        }
    };
    return ChatText;
}(Base));
export { ChatText };
